import {useMediaQuery} from '@mui/material'
import {ReactElement, useMemo} from 'react'
import {Link} from 'react-router-dom'
import {useChatPairConnection, useOpenDialog} from 'entities/messages'
import {useProfile} from 'entities/profile'
import {ChatPrice} from '../chatPrice'
import {FaceClouds, FaceSwear, FaceZipper} from './icon/icons'
import styles from './styles.module.scss'

export const ChatBlock = () => {
  const {isBlock, isBlockMe} = useChatPairConnection()
  const openDialog = useOpenDialog()
  const profile = useProfile()
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  const header = useMemo(() => {
    if (openDialog?.interlocutor.isBlocked || profile.isBlocked) return 'Deactivated user'

    return isBlock ? 'You have blocked a user' : 'You have been blocked by a user'
  }, [openDialog, profile, isBlock, isBlockMe])

  const icon: ReactElement = useMemo(() => {
    if (openDialog?.interlocutor.isBlocked || profile.isBlocked) return <FaceClouds />

    return isBlock ? <FaceSwear /> : <FaceZipper />
  }, [openDialog, profile, isBlock, isBlockMe])

  const className = useMemo(() => {
    if (openDialog?.interlocutor.isBlocked || profile.isBlocked) return styles.isBlockUser

    return isBlock ? styles.isBlock : styles.isBlockMe
  }, [openDialog, profile, isBlock, isBlockMe])

  return (
    <>
      <div className={styles.root}>
        <div className={styles.wrapper}>
          <div className={`${styles.icon} ${className}`}>{icon}</div>
          <div>
            <div className={styles.textHeader}>{header}</div>
            <div className={styles.text}>
              This user was blocked due to our <Link to='/terms-of-use' className={styles.terms}>Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>

      {!is768p ? <ChatPrice /> : null}
    </>
  )
}
